import { useDispatch } from '@witmetrics/data-store';
import { API } from '@/api';
import { showSuccessToaster } from '@/utils/toasters';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import { TrashIcon } from '@/icons';
import DefaultDialog from '@/components/Dialog/DefaultDialog';

export type DeleteFileCollectionDialogProps = {
  fileCollectionId: number;
  onDelete?: (fileCollectionId: number) => void;
  onClose: () => void;
};

export default function DeleteFileCollectionDialog({
  fileCollectionId,
  onDelete,
  onClose,
}: DeleteFileCollectionDialogProps) {
  const dispatch = useDispatch();
  const { onApiError } = useAppState();
  const [isDeleting, toggleDeleting] = useToggle();

  const handleDelete = async () => {
    try {
      toggleDeleting(true);
      await API.FileCollections.removeFileCollection(fileCollectionId);
      dispatch.deleteFileCollection({ fileCollectionId });
      if (onDelete) onDelete(fileCollectionId);
      showSuccessToaster('File collection deleted');
      toggleDeleting(false);
      onClose();
    } catch (err) {
      toggleDeleting(false);
      onApiError(err, 'Error deleting file collection', () => {
        handleDelete();
      });
    }
  };

  return (
    <DefaultDialog
      disabled={isDeleting}
      pending={isDeleting}
      variant="confirm"
      icon={<TrashIcon size="1.375rem" />}
      confirmLabel="Delete"
      pendingLabel="Deleting"
      title="Delete file collection"
      message="Are you sure you want to remove this file collection? All files in this collection will also be deleted. This action cannot be undone."
      onCancel={onClose}
      onConfirm={handleDelete}
      onClose={onClose}
    />
  );
}
